<template>
  <div class="page-content">
    <!-- 顶部 top -->
    <!-- <div class="tap-title">
      <span>角色管理</span>
    </div> -->

    <!-- 角色搜索以及添加栏目 -->
    <div class="product-menu">
      <div class="left">
        <el-button type="primary" class="first-btn" @click="addRole">添加角色</el-button>
      </div>
      <div class="right" style="width: 18%">
        <el-input placeholder="请输入角色名称" v-model.trim="roleName" class="input-with-select" >
          <el-button slot="append" icon="el-icon-search" @click="getRoleList"></el-button>
        </el-input>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="cellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <el-table-column
         prop="roleName"
          label="角色名称">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="角色描述">
        </el-table-column>
        <el-table-column
          prop="createUser"
          label="创建者">
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
             <div class="opreationBtn">
              <span class="check" @click="handlerClick('check',scope.row)">查看</span>
              <span class="edit" @click="handlerClick('edit',scope.row)">编辑</span>
              <span class="edit" @click="handlerClick('auth',scope.row)">分配权限</span>
              <span class="del"  @click="handlerClick('del',scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <paging :total="total" @changePage="changePage"/>
      <!-- <el-row :span="24" class="dataListOperation">
        <el-row :span="24" type="flex" justify="end">
            <div class="showAll"> 共<span>{{pageParams.total}}</span>个角色信息</div>
            <el-pagination
             layout="prev, pager, next"
             @current-change="currentPageChange"
              :page-size="pageParams.pageSize"
              :pager-count="11"
              :total="pageParams.total">
            </el-pagination>
          </el-row>
      </el-row> -->
    </div>
    <!--添加角色 -->
    <addRoleView
      v-if="addDialogVisible"
      :addDialogVisible="addDialogVisible"
      :editData="editData"
      :editType="editType"
      @update-role-list="getRoleList"
      @closeAddViewDialog="addDialogVisible = false"/>
     <!-- 查看角色 -->
    <roleView v-if="viewDialogVisible" :viewDialogVisible="viewDialogVisible" :viewData="viewData" @closeViewDialog="viewDialogVisible = false"/>
  </div>
</template>

<script>
import roleView from '@/components/systemMan/roleView'
import paging from '@/components/paging'
import addRoleView from '@/components/systemMan/addRoleView'
import { roleList, roleDel } from '@/api/auth'
export default {
  components: {
    roleView,
    addRoleView,
    paging
  },
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      tableData: [],
      // 设置表格的样式
      cellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      viewDialogVisible: false,
      addDialogVisible: false,
      viewData: null,
      editData: null,
      editType: null,
      pageParams: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      roleName: ''
    }
  },
  methods: {
    handlerClick (sty, row) {
      console.log('row:', row)
      switch (sty) {
        case 'check':
          this.viewDialogVisible = true
          this.viewData = Object.assign({}, row)
          break
        case 'auth':
          this.editType = 'auth'
          this.editData = Object.assign({}, row)
          this.addDialogVisible = true
          break
        case 'edit':
          this.editType = 'edit'
          this.editData = Object.assign({}, row)
          this.addDialogVisible = true
          break
        case 'del':
          this.$confirm('确定删除此记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            console.log('确定删除')
            this.deleteRole(row)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
          console.log('del', row)
          break
        default:
          break
      }
    },
    addRole () {
      this.editType = 'add'
      this.editData = null
      this.addDialogVisible = true
    },
    deleteRole (row) {
      console.log('row:', row)
      const params = {
        roleId: row.roleId
      }
      roleDel(params).then(res => {
        res = res.data
        console.log('删除返回数据：', res)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getRoleList()
        }
      })
    },
    getRoleList () {
      const params = {
        roleName: this.roleName,
        remark: '',
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      roleList(params).then(res => {
        res = res.data
        console.log('获取的角色列表数据:', res)
        this.total = res.data.total
        if (res.data.list && res.data.list) {
          this.tableData = res.data.list
        }
      })
    },
    // currentPageChange (num) {
    //   this.pageParams.pageNumber = num
    //   this.getRoleList()
    // },
    changePage (val) {
      this.listQuery = val
      this.getRoleList()
    }
  },
  created () {
    this.getRoleList()
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }
      .right{
        display: flex;
      }
    }

    .dataList{
      background-color: white;
      .opreationBtn{
        .check{
          color: #35a6df;
          cursor: pointer;
        }
        .edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
